import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { TextField } from 'material-ui';

import Months from '../../../../utils/Months';
import './MonthlyFixedInputs.css';
import '../../../../grid.css';

class MonthlyFixedInputs extends Component {
    handleMonthlyFixedChange(value, month) {
        const { setMonthlyFixedInputs } = this.props;
        setMonthlyFixedInputs(Number(value), month);
    }

    render() {
        const { mFixedCharge, isLocked } = this.props;
        return (
            <div>
                {Months.map(month => (
                    <div className="TextFields" key={month}>
                        <TextField
                            onChange={(e, value) => {
                                this.handleMonthlyFixedChange(value, month);
                            }}
                            disabled={isLocked}
                            defaultValue={mFixedCharge[month]}
                            floatingLabelText={month}
                        />
                    </div>
                ))}
            </div>
        );
    }
}

MonthlyFixedInputs.propTypes = {
    isLocked: PropTypes.bool.isRequired,
    mFixedCharge: PropTypes.object.isRequired,
    setMonthlyFixedInputs: PropTypes.func.isRequired,
};

export default MonthlyFixedInputs;



// WEBPACK FOOTER //
// ./src/containers/Inputs/UtilityInputs/MonthlyFixedInputs/MonthlyFixedInputs.js